import { css, cx } from "@emotion/css";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import type { ReactNode } from "react";
import { resetStyles } from "../../utils";
import { ActionButton, ActionButtonType } from "../Button";
export interface AdvancedFilterPanelProps {
    content: ReactNode;
    onResetFilter: () => void;
    isResetEnabled: boolean;
    parentOrientation: "row" | "column";
}
export function AdvancedFilterPanel({ content, onResetFilter, isResetEnabled, parentOrientation }: AdvancedFilterPanelProps) {
    return (<div className={cx(advancedFilterPanelStyles.container, {
            [advancedFilterPanelStyles.inRow]: parentOrientation === "row",
            [advancedFilterPanelStyles.inColumn]: parentOrientation === "column",
        })}>
            <div className={advancedFilterPanelStyles.header}>
                <h4 className={advancedFilterPanelStyles.heading}>Advanced filter</h4>
                <ActionButton disabled={!isResetEnabled} label="Reset" type={ActionButtonType.Secondary} onClick={() => onResetFilter()}/>
            </div>
            {content}
        </div>);
}
const advancedFilterPanelStyles = {
    container: css({
        display: "flex",
        flexDirection: "column",
        padding: `${space[16]} ${space[32]} ${space[16]} ${space[16]}`,
        gap: space[8],
        minWidth: "304px",
    }),
    inRow: css({
        width: "17.6rem",
    }),
    inColumn: css({
        borderTop: `1px solid ${themeTokens.color.border.primary}`,
    }),
    header: css({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: space[16],
    }),
    heading: css({
        ...resetStyles.heading,
        font: text.body.bold.large,
        color: themeTokens.color.text.primary,
    }),
};
